export default __webpack_public_path__ + "static/media/Leg_left.94856f3b.svg";